import Vue from "vue";
import VueRouter from "vue-router";

// Router configuration
Vue.use(VueRouter);
import MapPage from '../views/MapPage';
import Coupons from '../views/Coupons';
import Profile from '../views/Profile';
import Forum from '../views/Forum';
import Home from '../views/Home';

const routes = [
  {path: '/map', component:MapPage, name:'Map'},
  {path: '/coupons', component:Coupons, name:'Coupons'},
  {path: '/profile', component:Profile, name:'Profile'},
  {path: '/forum', component:Forum, name:'Forum'},
  {path: '/home', component:Home, name:'Home'},
  {path: '/', redirect:'Home'},
]

const router = new VueRouter({
  routes
});

export default router;